import React, {useEffect, useLayoutEffect, useState} from "react";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {makeStyles} from "@material-ui/core/styles";
import {Link, useHistory} from "react-router-dom";
import ChatContainer from "../../Components/ChatContainer";
import VetAppointmentView from "../../Components/VetAppointmentView";
import {useLocation} from "react-router";
import {getAppointment} from "../../redux/appointment/appointment.actions";
import API from "../../helpers/apiHelpers";
import {setChat} from "../../redux/chat/chat.actions";
import moment from "moment/moment";
import WebFont from "webfontloader";
import {getBranding} from "../../redux/branding/branding.actions";

const useStyle = makeStyles(() => ({
}));
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
const JoinRoom = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const apptId = location.pathname.substr(10);

    useEffect(() => {
        getAppointment(apptId)
            .then(async res => {
                const scheduledTime = moment(res.scheduledDate);
                const timeDiff = scheduledTime.diff(moment(), "minutes");
                if (res.status === "CANCELLED") {
                    history.push("/appointments", "notExist");
                    return;
                }
                if (timeDiff > 6) {
                    history.push("/appointments", "future");
                    return;
                }
                if (res.finished) {
                    history.push("/appointments/past", "past");
                    return;
                }
                if (res.status === "PENDING") {
                    history.push("/appointments", "future");
                    return;
                }
                const vetProfile = await API.getProfiles({userId: res.vetUserId});
                dispatch(setChat({data: {item: res, vetProfile: vetProfile[0]}, over: false}));
                history.push("/chat?isJoin=true");
            })
            .catch(err => {
                history.push("/appointments", "notExist");
            });
    },[]);
    return (
        <div>
        </div>
    );
};

export default JoinRoom;
